import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FooterV2 from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FooterV2);
